import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Image, Badge, Container, OverlayTrigger, Tooltip } from 'react-bootstrap'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  render() {

    const { ajax_data, page_data, changeTopSearch, changeLeftMenuh, favorite, cart } = this.props

    const content = (
      <>
        <div className={styles.firstng_top}>
          <div style={{ width: '33%', flex: 'none' }} className='d-flex align-items-center justify-content-start'>
            <div onClick={() => changeLeftMenuh()} className={styles.firstng_menubtn}>
              <svg width="34" height="7" viewBox="0 0 34 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 1H34" stroke="white"/>
                <path d="M0 6H27" stroke="white"/>
              </svg>
            </div>
            {page_data.phone &&
              <a href={`tel:` + page_data.phone.replace(/[-()\s]/g, '')} className={styles.firstng_phone + ` d-none d-lg-block`}>{page_data.phone}</a>
            }
            {page_data.tg &&
              <a href={page_data.tg} className={styles.firstng_tg + ` d-none d-lg-flex`}>
                <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.05925 6.76887C1.05925 6.76887 7.74253 3.8049 10.0604 2.76122C10.949 2.34378 13.9622 1.00786 13.9622 1.00786C13.9622 1.00786 15.353 0.423446 15.2371 1.8428C15.1984 2.42727 14.8894 4.47281 14.5803 6.68538C14.1167 9.81637 13.6145 13.2395 13.6145 13.2395C13.6145 13.2395 13.5373 14.1997 12.8805 14.3667C12.2238 14.5337 11.1421 13.7823 10.949 13.6153C10.7944 13.4901 8.05157 11.6115 7.04715 10.693C6.77672 10.4426 6.46768 9.94164 7.08575 9.35716C8.47652 7.97953 10.1377 6.26794 11.1421 5.18254C11.6057 4.68156 12.0692 3.51267 10.1377 4.93202C7.39484 6.97762 4.69062 8.89795 4.69062 8.89795C4.69062 8.89795 4.0725 9.31539 2.91357 8.93966C1.75458 8.564 0.402469 8.06301 0.402469 8.06301C0.402469 8.06301 -0.524636 7.43683 1.05925 6.76887Z" fill="white"/>
                </svg>
              </a>
            }
          </div>
          <a href="/">
            <Image alt="Лого" src="/files/images/logo.svg" width={155} height={56} className={styles.firstng_logo} />
          </a>
          <div style={{ width: '33%', flex: 'none' }} className='d-flex align-items-center justify-content-end'>
            <OverlayTrigger overlay={<Tooltip id={`color_overlay_incart_stock`}>Поиск</Tooltip>}>
              <div onClick={() => changeTopSearch()} className={styles.firstng_icon + ` position-relative d-none d-md-flex`}>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.75 11.75L17.25 17.25M7.16667 13.5833C3.62284 13.5833 0.75 10.7105 0.75 7.16667C0.75 3.62284 3.62284 0.75 7.16667 0.75C10.7105 0.75 13.5833 3.62284 13.5833 7.16667C13.5833 10.7105 10.7105 13.5833 7.16667 13.5833Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </OverlayTrigger>
            <OverlayTrigger overlay={<Tooltip id={`color_overlay_incart_stock`}>Избранное</Tooltip>}>
              <a href={page_data.favorite_link} className={styles.firstng_icon + ` position-relative d-none d-md-flex`}>
                <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 4.2002V13.6854C1 15.0464 1 15.7268 1.20412 16.1433C1.58245 16.9151 2.41157 17.3588 3.26367 17.2454C3.7234 17.1842 4.28964 16.8067 5.4221 16.0518L5.42481 16.0499C5.87368 15.7507 6.09815 15.6011 6.33295 15.5181C6.76421 15.3656 7.23476 15.3656 7.66602 15.5181C7.90129 15.6012 8.12664 15.7515 8.57732 16.0519C9.70978 16.8069 10.2767 17.1841 10.7364 17.2452C11.5885 17.3586 12.4176 16.9151 12.7959 16.1433C13 15.7269 13 15.0462 13 13.6854V4.19691C13 3.07899 13 2.5192 12.7822 2.0918C12.5905 1.71547 12.2837 1.40973 11.9074 1.21799C11.4796 1 10.9203 1 9.8002 1H4.2002C3.08009 1 2.51962 1 2.0918 1.21799C1.71547 1.40973 1.40973 1.71547 1.21799 2.0918C1 2.51962 1 3.08009 1 4.2002Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {favorite.length > 0 &&
                  <Badge className={styles.firstng_badge + ` position-absolute top-0 start-100 translate-middle`} pill bg="danger">{favorite.length}</Badge>
                }
              </a>
            </OverlayTrigger>
            <OverlayTrigger overlay={<Tooltip id={`color_overlay_incart_stock`}>Личный кабинет</Tooltip>}>
              <a href={page_data.kabinet_link} className={styles.firstng_icon + ` position-relative`}>
                <svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.5 17.5835C13.5 15.1903 10.5899 13.2502 7 13.2502C3.41015 13.2502 0.5 15.1903 0.5 17.5835M7 10.0002C4.60677 10.0002 2.66667 8.06006 2.66667 5.66683C2.66667 3.2736 4.60677 1.3335 7 1.3335C9.39323 1.3335 11.3333 3.2736 11.3333 5.66683C11.3333 8.06006 9.39323 10.0002 7 10.0002Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            </OverlayTrigger>
            <OverlayTrigger overlay={<Tooltip id={`color_overlay_incart_stock`}>Корзина</Tooltip>}>
              <a href={page_data.cart_link} className={styles.firstng_icon + ` position-relative d-none d-md-flex`}>
                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.7083 15.7083C14.5577 15.7083 13.625 16.6411 13.625 17.7917C13.625 18.9423 14.5577 19.875 15.7083 19.875C16.8589 19.875 17.7917 18.9423 17.7917 17.7917C17.7917 16.6411 16.8589 15.7083 15.7083 15.7083ZM15.7083 15.7083H7.68119C7.20092 15.7083 6.96034 15.7083 6.76261 15.6229C6.58818 15.5475 6.43686 15.4262 6.3266 15.2714C6.20302 15.0979 6.15332 14.866 6.05494 14.4068L3.49113 2.44234C3.39046 1.97254 3.33945 1.73789 3.21444 1.56242C3.10418 1.40766 2.95288 1.28585 2.77845 1.21047C2.58068 1.125 2.34145 1.125 1.86097 1.125H1.125M4.25 4.25H17.6596C18.4115 4.25 18.787 4.25 19.0393 4.40662C19.2604 4.54382 19.4222 4.75898 19.4928 5.00938C19.5733 5.29524 19.4698 5.65621 19.2614 6.3786L17.8191 11.3786C17.6945 11.8105 17.6322 12.0261 17.5058 12.1863C17.3942 12.3278 17.2471 12.4385 17.0803 12.5065C16.8918 12.5833 16.6678 12.5833 16.2209 12.5833H6.05257M6.33333 19.875C5.18274 19.875 4.25 18.9423 4.25 17.7917C4.25 16.6411 5.18274 15.7083 6.33333 15.7083C7.48393 15.7083 8.41667 16.6411 8.41667 17.7917C8.41667 18.9423 7.48393 19.875 6.33333 19.875Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {cart.length > 0 &&
                  <Badge className={styles.firstng_badge + ` position-absolute top-0 start-100 translate-middle`} pill bg="danger">{cart.length}</Badge>
                }
              </a>
            </OverlayTrigger>
          </div>
        </div>
        <div className={styles.firstng_about_content}>
          <Container>
            <div className='d-flex flex-column flex-lg-row align-items-center justify-content-between'>
              <div>
                <div className='d-flex flex-column-reverse flex-lg-row align-items-center'>
                  <div className={styles.firstng_about_longtitle}>{ajax_data.longtitle}</div>
                  <Image className={styles.firstng_about_logo} src="./files/images/about_logo.svg" width="57" height="57" />
                </div>
                <div className={styles.firstng_about_introtext}>{ajax_data.introtext}</div>
              </div>
              <a target="_blank" href="https://yandex.ru/maps/org/bruno_altro/160467838800/?ll=37.617222%2C55.761457&z=16">
                <Image className={styles.firstng_about_rating} src="./files/images/rating_plashka.svg" width="340" height="72" />
              </a>
            </div>
          </Container>
        </div>
      </>
    )

    return (
      <>
        <div style={{ background: `url('` + ajax_data.image + `') no-repeat center`, backgroundSize: `cover` }} className={styles.firstng_about}>
          {content}
        </div>
        <div style={{ background: `url('` + ajax_data.image_mob + `') no-repeat center`, backgroundSize: `cover` }} className={styles.firstng_about_mob}>
          {content}
        </div>
      </>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object,
  page_data: PropTypes.object,
  changeTopSearch: PropTypes.func,
  changeLeftMenuh: PropTypes.func,
  favorite: PropTypes.array,
  cart: PropTypes.array
}